export enum Agent {
    Urlaub = 'urlaub',
    UrlaubAt = 'urlaub.at',
    Affiliate = 'affiliate',
}
